Shopify.cardProductSlider = function (el) {
  document.querySelectorAll(el).forEach((container) => {
    const parent = container.closest('.card__media');
    const swiper = new Swiper(container, {
      loop: true,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      pagination: {
        el: parent.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: parent.querySelector('.swiper-button-next'),
        prevEl: parent.querySelector('.swiper-button-prev'),
      },
      a11y: true,
    });

    swiper.on('slideChange', () => {
      swiper.pagination.render();
      swiper.pagination.update();
    });
  });
};
